import { LAYER_IDS } from '@tmapy/config';
import { actionSetLayerFeatures, geoJSONToFeature, getFeatureFromLayer } from '@tmapy/mapcore';
export const actionCreateLineSplitPoint = (payload, coordinate) => async (dispatch, getState) => {
    if (payload?.layerId !== LAYER_IDS.EDIT_TOOLS_HIGHLIGHT) {
        dispatch(actionSetLayerFeatures(LAYER_IDS.EDIT_TOOLS_SNAP, []));
        return;
    }
    const state = getState();
    const geoJSONFeature = getFeatureFromLayer(state.mapCore.layers, payload.layerId, payload.featureId);
    const feature = geoJSONFeature ? geoJSONToFeature(geoJSONFeature) : null;
    if (!feature) {
        dispatch(actionSetLayerFeatures(LAYER_IDS.EDIT_TOOLS_SNAP, []));
        return;
    }
    const coordinates = feature.getGeometry().getClosestPoint(coordinate);
    const point = {
        geometry: {
            type: 'Point',
            coordinates,
        },
        properties: {},
        type: 'Feature',
    };
    dispatch(actionSetLayerFeatures(LAYER_IDS.EDIT_TOOLS_SNAP, [point]));
};
//# sourceMappingURL=actionCreateLineSplitPoint.js.map